import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import GenerativeModelsTabState from './GenerativeModelsTabState';
import GenerativeModelsView from './GenerativeModelsView';

export class GenerativeModelsTabView extends Backbone.View<GenerativeModelsTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    const currentEntityType = this.model.get('currentEntityType');
    renderToDOM(
      <GenerativeModelsView
        currentEntityType={currentEntityType}
        targetId={this.model.get('currentEntityId')}
      />,
      this.el
    );
    return this;
  }

  override remove(): Backbone.View<GenerativeModelsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}
GenerativeModelsTabView.initClass();

export default GenerativeModelsTabView;
